import { Image, File, FileText, FileSpreadsheet, FileArchive, Mail } from "lucide-react";
import React from "react";

// MIME types for different file categories
const TEXT_MIME_TYPES = ["text/plain", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
const PDF_MIME_TYPES = ["application/pdf"];
const SPREADSHEET_MIME_TYPES = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv", "application/vnd.ms-excel"];
const ZIP_MIME_TYPES = ["application/zip", "application/x-zip-compressed", "multipart/x-zip"];
const EMAIL_MIME_TYPES = ["message/rfc822"];

// Return the appropriate icon based on the file type
const FileIcon = (props: { mimeType: string; className?: string }): React.JSX.Element => {
    const { mimeType, className } = props;
    const iconClassName = className || "h-4 w-4 stroke-stone-400";

    if (mimeType.startsWith("image/")) {
        // Images and gifs
        return <Image className={iconClassName} />;
    } else if (TEXT_MIME_TYPES.includes(mimeType)) {
        // Text files and Word documents
        return <FileText className={iconClassName} />;
    } else if (PDF_MIME_TYPES.includes(mimeType)) {
        // PDFs
        return <FileText className={iconClassName} />;
    } else if (SPREADSHEET_MIME_TYPES.includes(mimeType)) {
        // Spreadsheets
        return <FileSpreadsheet className={iconClassName} />;
    } else if (ZIP_MIME_TYPES.includes(mimeType)) {
        // ZIP archives
        return <FileArchive className={iconClassName} />;
    } else if (EMAIL_MIME_TYPES.includes(mimeType)) {
        // Email files
        return <Mail className={iconClassName} />;
    } else {
        return <File className={iconClassName} />;
    }
};

export default FileIcon;
